import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromBcp from './bcp.reducer';

export const selectBcpState = createFeatureSelector<fromBcp.State>(
  fromBcp.bcpFeatureKey
);

export const getBcps = createSelector(selectBcpState, (state) => ({
  bcps: state.bcps,
  count: state.count,
}));

export const getBcp = createSelector(getBcps, (state, action) =>
  state.bcps.find((bcp) => bcp.id === action.id)
);

export const getRecoveryPhases = createSelector(
  selectBcpState,
  (state, action) =>
    state.recoveryPhases.filter(
      (rp) => rp.recoveryPhaseType.id === action.recoveryPhaseTypeId
    )
);
export const getScenarios = createSelector(
  selectBcpState,
  (state) => state.bcpScenarios
);

export const getAdInfo = createSelector(selectBcpState, (state, props) => {
  return state.adInfo[props.id];
});

export const getStaffRequirements = createSelector(
  selectBcpState,
  (state, props) => {
    const { records, payload } = state.staffRequirements;

    if (
      payload.locationId === props.locationId &&
      payload.biaIds.length === props.biaIds.length &&
      payload.biaIds.every((biaId) => payload.biaIds.includes(biaId))
    ) {
      return records;
    }
    return [];
  }
);
